import { createContext } from '@lyearn/core/utils/context';

interface MultiStepContextValue {
  activeStepId: string;
  setStep: (step: string) => void;
}

export const [MultiStepProvider, useMultiStepContext] =
  createContext<MultiStepContextValue>('MultiStep');
